import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { controlStaffService } from '@/services/control/staff-service';

import { adminMutationKeys, adminQueryKeys } from '@/hooks/admin/query-keys';

/**
 * Revoke tenant_creator from one email. Takes effect on that person's next
 * request, not at token expiry (control PR #1822 resolves the tier per
 * request). Read-after-write consistent, so one invalidation refreshes the
 * list; see `useGrantTenantCreator`.
 */
export function useRevokeTenantCreator(): UseMutationResult<
  void,
  Error,
  string
> {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationKey: adminMutationKeys.revokeTenantCreator(),
    mutationFn: (email) => controlStaffService.revokeTenantCreator(email),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: adminQueryKeys.staffMembers(),
      }),
  });
}
